import { format } from 'date-fns';

export function parseDateFromUrl(dateString) {
  try {
    const parsedDate = new Date(decodeURIComponent(dateString));

    if (isNaN(parsedDate.getTime())) {
      return null;
    }

    // Formata a data para yyyy-MM-dd
    return format(parsedDate, 'yyyy-MM-dd');
  } catch (error) {
    console.error('Erro ao parsear a data:', error);
    return null;
  }
}
